import { useMutation } from "@tanstack/react-query";
import {
  uploadCertificateCancelAPI,
  uploadCertificateDeleteAPI,
} from "./certificates.api";
import { handleNetworkError } from "@repo/ui/libs";

const useUploadCertificateCancellationMutation = () => {
  return useMutation({
    mutationFn: uploadCertificateCancelAPI,
    onError: handleNetworkError,
  });
};
const useUploadCertificateDeletionMutation = () => {
  return useMutation({
    mutationFn: uploadCertificateDeleteAPI,
    onError: handleNetworkError,
  });
};

export {
  useUploadCertificateCancellationMutation,
  useUploadCertificateDeletionMutation,
};
